// extracted by mini-css-extract-plugin
module.exports = {"skill":"Skill_skill__3Wvot","icon":"Skill_icon__tnVfC","logo":"Skill_logo__27KM2"};